import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/app/(marketing)/page.tsx");
